import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";

import { Modal } from "react-bootstrap";

// Main component
export default function VideoPlayerModal({ open, onClose, videoUrl }) {
  const [embeddedUrl, setEmbeddedUrl] = useState(videoUrl);

  useEffect(() => {
    const normalizeVideoUrl = () => {
      try {
        if (!videoUrl) return;
        const urlObj = new URL(videoUrl);
        let finalUrl = videoUrl;

        // ✅ handle youtube.com/watch?v=... - normalize to watch format
        if (
          urlObj.hostname.includes("youtube.com") &&
          urlObj.searchParams.get("v")
        ) {
          const videoId = urlObj.searchParams.get("v");
          finalUrl = `https://www.youtube.com/watch?v=${videoId}`;
        }
        // ✅ handle youtu.be/... - convert to watch format
        else if (urlObj.hostname === "youtu.be") {
          const videoId = urlObj.pathname.slice(1);
          finalUrl = `https://www.youtube.com/watch?v=${videoId}`;
        }
        // ✅ handle youtube.com/embed/... - convert to watch format
        else if (
          urlObj.hostname.includes("youtube.com") &&
          urlObj.pathname.includes("/embed/")
        ) {
          const videoId = urlObj.pathname.split("/embed/")[1];
          finalUrl = `https://www.youtube.com/watch?v=${videoId}`;
        }
        setEmbeddedUrl(finalUrl);
      } catch (err) {
        console.error("Invalid video URL:", err);
        setEmbeddedUrl(videoUrl);
      }
    };
    normalizeVideoUrl();
  }, [videoUrl]);

  return (
    <Modal show={open} onHide={onClose} centered size="lg">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div
          style={{
            position: "relative",
            paddingTop: "56.25%",
          }}
        >
          <ReactPlayer
            src={embeddedUrl}
            controls
            playing={open}
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            config={{
              youtube: {
                playerVars: {
                  origin: window.location.origin,
                  enablejsapi: 1,
                  modestbranding: 1,
                  
                },
              },
            }}
          />
          {/* <video controls width="250">
            <source src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4" type="video/mp4" />
          </video> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}
